import { DocumentsSection } from "@/components/_organisms/documents-section";
import { useGetFileListByOwner } from "@/domain/_shared/file/hooks/api/use-get-file-list-by-owner";
import { OwnerTypes } from "@/domain/_shared/lib/owner-types";

interface DataRequestDocumentsSectionProps {
  ownerId: string;
  isEditing: boolean;
  label: string;
  className?: string;
}

export function DataRequestDocumentsSection({
  ownerId,
  isEditing,
  label,
  className,
}: DataRequestDocumentsSectionProps) {
  const { fileList, queryResult } = useGetFileListByOwner({ ownerId, ownerType: OwnerTypes.DATA_REQUEST_ENTITY });

  return (
    <div className={className}>
      <h2 className="mb-2 text-sm font-medium">{label}</h2>
      <DocumentsSection
        ownerId={ownerId}
        ownerType={OwnerTypes.DATA_REQUEST_ENTITY}
        isEditing={isEditing}
        fileList={fileList}
        isLoading={queryResult.isLoading}
      />
    </div>
  );
}
